import {getAuthenticatedThemisClient, AdminFileIdView} from '@modifi/onboarding-api-clients'
import {updateFactory, Reducer} from '@modifi/redux'
import {DocumentTypeVal} from '@modifi/enums'
import {aFetchDocumentsByExternalPersonId} from './collection'
import {NestedError} from '../../utils'

const apiClient = getAuthenticatedThemisClient()

const sendAttachRequest = (externalPersonId: string, document: AdminFileIdView): Promise<void> =>
  apiClient.Person.attachDocument({
    externalPersonId,
    body: document,
  }).then(() => undefined)
const sendDetachRequest = (externalPersonId: string, fileId: string): Promise<void> =>
  apiClient.Person.detachDocument({externalPersonId, fileId}).then(() => undefined)

type UpdatePersonDocumentsChanges = {
  added: {fileId: string; documentType: DocumentTypeVal}[]
  removed: string[]
  modifications?: {fileId: string; [k: string]: any}[]
}

const {reducer, actions} = updateFactory({
  actionNamePrefix: 'data/personDocuments/update',
  rootSelector: state => state?.data?.personDocuments?.update,
  submitRequest:
    (a, externalPersonId: string, changes: UpdatePersonDocumentsChanges) =>
    async (dispatch): Promise<void> => {
      dispatch(a.pendingAction())
      try {
        await Promise.all(
          (changes?.added || []).map(file => sendAttachRequest(externalPersonId, file))
        )
        await Promise.all(
          (changes.removed || []).map(fileId => sendDetachRequest(externalPersonId, fileId))
        )
        if (changes.modifications && changes.modifications?.length > 0) {
          // eslint-disable-next-line no-console
          console.warn('Updating files is currently not supported')
        }
        dispatch(a.successAction())
      } catch (e: any) {
        dispatch(a.errorAction(e))
        throw new NestedError(
          `Error while calling Person.attachDocument or Person.detachDocument endpoint`,
          e
        )
      }
      dispatch(aFetchDocumentsByExternalPersonId(externalPersonId))
    },
})

export default reducer as Reducer

export const {aSubmit: aUpdatePersonDocuments} = actions
